import AmexCenturionNYRecurringEvents from './AmexCenturionNYRecurringEvents';

export default AmexCenturionNYRecurringEvents;
